exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".hotel-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  max-width: 600px;\n  width: 100%;\n  color: #42ebf4;\n  background: rgba(0, 0, 0, 0.25);\n  padding: 1rem;\n  font-size: 30px; }\n  .hotel-form h3,\n  .hotel-form input {\n    margin-bottom: 5%; }\n  .hotel-form button {\n    align-self: flex-end;\n    max-width: 300px;\n    background-color: #0a244f;\n    color: #42ebf4; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/hotels/components/HotelForm.scss
// module id = 96
// module chunks = 0